import { RadioactiveOffIcon } from './RadioactiveOffIcon';

/**
 * author: TheChilliPL
 * id 3AD51A23-9040-4D23-AE50-B28C6DFF82F6
 * name radioactive-off
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/radioactive-off.svg
 * tags
 * - Science 
 */
export const RadiationOffIcon = RadioactiveOffIcon;
export default RadiationOffIcon